import React from 'react';
import ScrollableMenu from '../../internals/components/ScrollableMenu';

function ScrollableMenuGames() {
    const menuItems = [
        { label: "Match 3", image: "/images/gamesIcon/SpellBrown.png", route: "/games/match-3" },
        { label: "Bubble Shooter", image: "/images/gamesIcon/SpellGreen.png", route: "/games/bubble-shooter" },
        { label: "Puzzle", image: "/images/gamesIcon/Coin.png", route: "/games/puzzle" },
        { label: "Quiz", image: "/images/gamesIcon/Gems.png", route: "/games/quiz" },
        { label: "Cards", image: "/images/gamesIcon/Meat.png", route: "/games/cards" },
        { label: "Girls", image: "/images/gamesIcon/War.png", route: "/games/girls" },
        { label: "Jump & Run", image: "/images/gamesIcon/Rookie.png", route: "/games/jump-and-run" },
        { label: "Arcade", image: "/images/gamesIcon/Lord.png", route: "/games/arcade" },
        { label: "Racing", image: "/images/gamesIcon/Sword.png", route: "/games/racing" },
        { label: "Sport", image: "/images/gamesIcon/Axe.png", route: "/games/sport" },
    ];

    return (
        <ScrollableMenu
            menuItems={menuItems}
            avatarStyle={{ width: 40, height: 40 }}
            labelStyle={{ fontSize: 14, color: '#333' }}
        />
    );
}

export default ScrollableMenuGames;
